import { render, staticRenderFns } from "./Catalogos.vue?vue&type=template&id=0ff34dbc&scoped=true"
import script from "./Catalogos.vue?vue&type=script&lang=js"
export * from "./Catalogos.vue?vue&type=script&lang=js"
import style0 from "./Catalogos.vue?vue&type=style&index=0&id=0ff34dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff34dbc",
  null
  
)

export default component.exports